import clsx from 'clsx';
import { CSSProperties } from 'react';
import * as React from 'react';

import AddIcon from 'assets/img/add_icon.svg?react';
import styles from './FabButton.module.scss';

export enum ButtonWidth {
  Fullwidth = 'fullwidth',
}

export enum ButtonColor {
  Default = 'default',
  Primary = 'primary',
  Secondary = 'secondary',
  Danger = 'danger',
}

export type ButtonProps = {
  id?: string;
  type?: 'submit' | 'button';
  title?: string;
  width?: ButtonWidth;
  className?: string;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  style?: CSSProperties;
  testId?: string;
  icon?: React.ReactNode;
};

export const FabButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  function Button(props, ref) {
    const { width, className, disabled, icon, ...rest } = {
      ...DefaultProps,
      ...props,
    };

    const buttonStyles = [className, styles.button, styles[`${width}-button`]];
    return (
      <div className={styles.button_container}>
        <button
          ref={ref}
          type={props.type ?? 'button'}
          data-disabled={disabled}
          {...rest}
          className={clsx(buttonStyles)}
          data-test-id={props.testId}
        >
          {icon || <AddIcon className={styles.addIcon} />}
        </button>
      </div>
    );
  },
);

const DefaultProps: Partial<ButtonProps> = {};
